import { render, staticRenderFns } from "./PermissionDescriptionKYY.vue?vue&type=template&id=73943e90&scoped=true"
import script from "./PermissionDescriptionKYY.vue?vue&type=script&lang=js"
export * from "./PermissionDescriptionKYY.vue?vue&type=script&lang=js"
import style0 from "./PermissionDescriptionKYY.vue?vue&type=style&index=0&id=73943e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73943e90",
  null
  
)

export default component.exports